module.exports = __webpack_public_path__ + "static/media/logo.223bf3a9.png";